import { Icon, Shadow, Tooltip } from '@genial/components';
import { Color } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Box } from 'native-base';

import { CustomerNameIconProps } from '../../../models';

export const CustomerNameIcon = ({ name, isTooltip }: CustomerNameIconProps) => {
  const size = useBreakpointValue({ base: 'xs', md: 'xxxxs' });

  const iconColor = {
    QualifiedClient: Color['brand.secondary.principal'],
    ProfessionalInvestor: Color['brand.tertiary.principal'],
  };

  const iconName = {
    QualifiedClient: 'Investidor qualificado',
    ProfessionalInvestor: 'Investidor profissional',
  };

  const iconComponent = (
    <Shadow testId="qa" borderRadius="full" level={1}>
      <Box
        bg="neutral.white"
        borderRadius="full"
        width={5}
        height={5}
        justifyContent="center"
        alignItems="center">
        <Icon
          testId="qa"
          name={name}
          size={size}
          color={iconColor[name] || iconColor.QualifiedClient}
        />
      </Box>
    </Shadow>
  );

  if (isTooltip) {
    return (
      <Tooltip testId="qa" label={iconName[name] || ''}>
        {iconComponent}
      </Tooltip>
    );
  }

  return iconComponent;
};
